import React from "react"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  render() {
    if (this.state.error) {
      // Callers that can degrade gracefully (a background that falls back to a
      // cheaper renderer) pass their own replacement instead of the error card.
      if (this.props.fallback !== undefined) return this.props.fallback
      return (
        <Box
          sx={{
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "var(--app-bg)",
            gap: 2,
            px: 4,
          }}
        >
          <Typography
            sx={{
              color: "var(--app-error)",
              fontFamily: "var(--app-font-mono)",
              fontSize: "0.75rem",
              letterSpacing: "0.2em",
            }}
          >
            RENDER ERROR
          </Typography>
          <Typography
            sx={{
              color: "rgba(var(--app-fg-rgb),0.35)",
              fontFamily: "var(--app-font-mono)",
              fontSize: "0.7rem",
              maxWidth: 600,
              textAlign: "center",
              lineHeight: 1.6,
            }}
          >
            {this.state.error?.message ?? String(this.state.error)}
          </Typography>
        </Box>
      )
    }
    return this.props.children
  }
}
